import type { TFunction } from 'i18next';

import type {
    VerticalScanUpdateSource,
    WinchMqttTopics,
    WinchStatusSnapshot,
} from '../winchMqttApi';

import { showWinchToast } from './winchMqttToasts';

export function withMeasurementPosition(
    current: WinchStatusSnapshot | null,
    measurement: { distance: number; depth: number }
): WinchStatusSnapshot {
    return {
        limits: current?.limits ?? null,
        speed: current?.speed ?? null,
        savedPositions: current?.savedPositions ?? [],
        servicePosition: current?.servicePosition ?? null,
        measurementPosition: measurement,
    };
}

/** Status `strictlimits` carries travel limits; do not overwrite getposition presets with status positions. */
export function limitsOnlySnapshot(snapshot: WinchStatusSnapshot): WinchStatusSnapshot {
    return {
        limits: snapshot.limits,
        speed: snapshot.speed,
        savedPositions: [],
        servicePosition: null,
        measurementPosition: null,
    };
}

/** Getposition carries named presets; do not overwrite status `strictlimits` or speed. */
export function presetsOnlySnapshot(snapshot: WinchStatusSnapshot): WinchStatusSnapshot {
    return {
        limits: null,
        speed: null,
        savedPositions: snapshot.savedPositions,
        servicePosition: snapshot.servicePosition,
        measurementPosition: snapshot.measurementPosition,
    };
}

export function scanUpdateSource(topic: string, topics: WinchMqttTopics): VerticalScanUpdateSource {
    if (topic === topics.subscribe.verticalScanEnable) {
        return 'enable';
    }
    if (topic === topics.subscribe.verticalScanDisable) {
        return 'disable';
    }
    if (topic === topics.subscribe.verticalScanSetLimits) {
        return 'setlimits';
    }
    return 'status';
}

export function toastWinchCommand(
    t: TFunction,
    success: boolean,
    successKey: string,
    errorKey: string,
    successId: string,
    errorId: string,
    /** `info` when the success means the command started, not that it finished. */
    successTone: 'success' | 'info' = 'success'
): void {
    showWinchToast(
        t(success ? successKey : errorKey),
        success ? successTone : 'error',
        success ? successId : errorId
    );
}
